"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthException_1 = __importDefault(require("../Exception/AuthException"));
exports.default = (e) => {
    if (e.message === "Request failed with status code 401") {
        return new AuthException_1.default();
    }
    return e;
};
//# sourceMappingURL=errorResponseTransformer.js.map